import { Box, styled } from '@mui/joy';

const SubtitleWrapper = styled(Box)({
  display: 'flex',
  gap: 8,
});

export default SubtitleWrapper;
